import React from 'react';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import '../../assets/css/General/Notfound.css';

const Notfound = () => {
    const navigate = useNavigate();

    const handleGoHome = () => {
        navigate('/');
    };

    return (
        <div className="notfound-container">
            <div className="notfound-wrapper">
                {/* 404 Illustration */}
                <div className="notfound-illustration">
                    <div className="notfound-404">404</div>
                </div>

                {/* Error Message */}
                <div className="notfound-content">
                    <h1 className="notfound-title">Page Not Found</h1>
                    <p className="notfound-subtitle">
                        Oops! The page you're looking for doesn't exist or has been moved.
                    </p>
                </div>

                {/* Action Buttons */}
                <div className="notfound-actions">
                    <Button
                        className="notfound-btn-primary"
                        onClick={handleGoHome}
                    >
                        Go to Home
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default Notfound;